import { useState, useMemo, useRef } from 'react';
import classes from './OldReportResult.module.css';
import useRoleplayHelper from 'features/realplays/RealPlay.helper';
import { imageBasePath } from 'constants';
import { InputSelect } from 'shared_ui_components';
import RoleplayLabel from 'features/roleplay/Components/Common/RoleplayLabel';
import ScenarioContext from './ScenarioContext';
import RoleplayRecording from './RoleplayRecording';
import Ratings from './Ratings';
import ImprovementGraph from './ImprovementGraph';
import Feedback from './Feedback';
import Strengths from './Strengths';
import Improvements from './Improvements';
import Transcription from './Transcription';

const OldNewReportResult = ({ data = {} }) => {
  const [selectedScenario, setSelectedScenario] = useState(data?.scenarios?.[0] || {});
  const playerRef = useRef(null);
  const { navigate, PATHS } = useRoleplayHelper();
  const title = data?.name;

  const prospectName = useMemo(
    () => data?.realplay_setting?.ai_persona?.name,
    [data?.realplay_setting]
  );
  const customer_role = useMemo(
    () => data?.realplay_setting?.customer_role,
    [data?.realplay_setting]
  );
  const customer_industry = useMemo(
    () => data?.realplay_setting?.customer_industry,
    [data?.realplay_setting]
  );
  const customer_situation = useMemo(
    () => data?.realplay_setting?.customer_situation,
    [data?.realplay_setting]
  );

  const scenarios = useMemo(() => data?.scenarios, [data?.scenarios]);
  const scenariosLength = useMemo(() => scenarios?.length || 0, [scenarios]);

  const formattedDate = () => {
    if (data?.end_date) {
      const date = new Date(data?.end_date);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses empiezan en 0
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
    return formatDate();
  };

  const options = useMemo(() => {
    if (!scenarios || scenarios?.length === 0) return [];
    return scenarios?.map((sc, i) => ({
      label: `${i + 1}. ${sc?.name}`,
      value: sc?.uuid,
    }));
  }, [scenarios]);

  const value = useMemo(() => {
    return (options ?? []).find((opt) => opt?.value === selectedScenario?.uuid);
  }, [options, selectedScenario]);

  const onSelectedValue = (value) => {
    const newList = {
      ...(scenarios ?? []).find((sce) => sce?.uuid === value),
    };
    setSelectedScenario(newList || {});
  };

  const videoURL = useMemo(() => selectedScenario?.response?.video, [selectedScenario?.response]);

  const rating_criteria = useMemo(
    () => selectedScenario?.response?.rating_criterials,
    [selectedScenario?.response]
  );
  const feedback = useMemo(() => selectedScenario?.response?.comment, [selectedScenario?.response]);

  const summary = useMemo(
    () => selectedScenario?.response?.summary,
    [selectedScenario?.response?.summary]
  );

  const userName = useMemo(
    () => `${data?.assigned_by_user?.first_name} ${data?.assigned_by_user?.last_name}`,
    [data?.assigned_by_user]
  );

  const assigned_by_user = useMemo(() => data?.assigned_by_user, [data?.assigned_by_user]);
  const client_profile_pic = useMemo(
    () => data?.realplay_setting?.ai_persona?.profile_pic,
    [data?.realplay_setting?.ai_persona]
  );

  const handleSeek = (timestamp) => {
    const seconds = parseFloat(timestamp);
    const player = playerRef.current;
    if (player) {
      player.seekTo(seconds, 'seconds');
      player.getInternalPlayer()?.play?.();
    }
  };

  return (
    <div>
      <div className={classes.headerContainer}>
        <div>
          <div>
            <div className={classes.header}>
              <button
                onClick={() => {
                  navigate(PATHS.ROLEPLAYS);
                }}
              >
                <img src={imageBasePath + 'back_arrow.svg'} alt="Return" />
              </button>
              <span className="heading4">
                Interactive Roleplay "{title}" {formattedDate()}
              </span>
              <RoleplayLabel {...data?.status} />
            </div>
            {scenariosLength > 1 && (
              <div className={classes.scenarioSelector}>
                <InputSelect
                  value={value}
                  onChange={(opt) => onSelectedValue(opt?.value || '')}
                  options={options}
                  closeMenuOnSelect
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={classes.gridContainer} style={{ marginTop: "20px" }}>
        <div className={classes.left}>
          {/* Scenario Context */}
          <ScenarioContext
            prospectName={prospectName}
            customer_role={customer_role}
            customer_industry={customer_industry}
            customer_situation={customer_situation}
            selectedScenario={selectedScenario}
            scenarios={scenarios}
            title={title}
          />
          {/* Roleplay Recording */}
          <RoleplayRecording videoURL={videoURL} playerRef={playerRef} />
          {/* Strengths */}
          <Strengths summary={summary} handleSeek={handleSeek} />
          {/* Practice & Improve */}
          <Improvements summary={summary} />
        </div>
        <div className={classes.right}>
          {/* Improvement*/}
          <ImprovementGraph
            assignment_uuid={data?.uuid}
            response_uuid={selectedScenario?.response?.uuid}
            mode={'view'}
          />
          {/*Overall Feedback*/}
          <Feedback feedback={feedback} readOnly />
          {/* Ratings & Why You Got Them*/}
          <Ratings rating_criteria={rating_criteria} onlyRead />
          {/* <div>
          <h4>😎 Upskill Yourselfe</h4>
          </div> */}
        </div>
      </div>
      <div className={classes.transcriptionContainer}>
        {/* Transcription*/}
        <Transcription
          assignment_uuid={data?.uuid}
          scenario_uuid={selectedScenario?.uuid}
          response_uuid={selectedScenario?.response?.uuid}
          clientName={prospectName}
          userName={userName}
          assigned_by_user={assigned_by_user}
          client_profile_pic={client_profile_pic}
        />
      </div>
    </div>
  );
};

export default OldNewReportResult;

const formatDate = () => {
  const dateString = new Date();

  let month = dateString.getUTCMonth() + 1;
  if (month < 10) month = `0${month}`;
  let day = dateString.getUTCDate();
  if (day < 10) day = `0${day}`;
  let year = dateString.getUTCFullYear();

  const newDate = day + '-' + month + '-' + year;
  return newDate;
};